// Function to get a cookie by name
function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

// Function to set a cookie
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// The HTML content to be added
const text = "<div class='cart-helper'><h4>Du hast Fragen oder brauchst Unterstützung bei deiner Bestellung?</h4><p>Schreib‘ uns eine Nachricht an <a href='mailto:info@speiskastl.at'>info@speiskastl.at</a> oder ruf uns an unter: <a href='tel:+43 676 371 47 40'>+43 676 371 47 40</a>.</p><span class='close'><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill=\"currentColor\" d=\"M15 0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-3.5 10.1-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z\"/></svg></span></span></div>";

// Check if the 'help' cookie is not set, then append the helper to the body
if (!getCookie('help')) {
    const div = document.createElement('div');
    div.innerHTML = text;
    document.body.appendChild(div.firstChild);

    // Add event listener to the close button
    document.querySelector('.cart-helper .close').addEventListener('click', function() {
        document.querySelector('.cart-helper').classList.remove('show');
        setCookie('help', true, 2);
    });

    // Show the helper after 10 seconds
    setTimeout(() => {
        document.querySelector('.cart-helper').classList.add('show');
    }, 15000);
}